<script setup>
import Footer from "../components/Footer";
import HeroSlider from "../components/HeroSlider";
import InfoPasos from "../components/InfoPasos";
import Breadcrumb from "../components/Breadcrumb";
</script>

<template>
  <HeroSlider />
  <InfoPasos />
  <Breadcrumb />

  <router-view />

  <Footer />
</template>

<style>
.text-dark {
  color: #1a1a1a !important;
}

.footer-header {
  border-bottom: 1px #fdc030 solid;
}

.bg-dark {
  background: #1a1a1a !important;
}

.fade-enter-active {
  transition: all 0.3s ease-out;
}

.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter-from,
.fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.form-control {
  background: transparent;
  border: none;
  border-bottom: 1px #b3b3b3 solid;
  border-radius: 0px;
}

.form-control:focus {
  box-shadow: none;
  background: transparent;
}

.bg-warning {
  background: #fdc030;
}
</style>
